import React from 'react';
import { QuoteIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { testimonials } from '../data/copy';
export function TestimonialsSection() {
  return <section className="defer-paint w-full bg-ink py-10 sm:py-14" aria-labelledby="testimonials-heading" data-id="element-205" data-mp="1n0ae5ipn6ux5">
      <div className="mx-auto max-w-6xl px-6" data-id="element-206" data-mp="1r142ueawsdr3">
        <SectionHeading title={<span id="testimonials-heading" data-id="element-208" data-mp="1qz9ip27gopo2">What futsal coaches are saying</span>} data-id="element-207" data-mp="1qzt0mix43e23" />

        <ul className="mt-10 grid gap-4 md:grid-cols-3 md:gap-5" data-id="element-209" data-mp="1d0jkfj8wojy4">
          {testimonials.map((testimonial, index) => <li key={`${testimonial.role}-${index}`} className="flex flex-col rounded-3xl border border-line bg-navy p-6 sm:p-7" data-id="element-210" data-mp="1hyuu9tz7augc" data-mpi={index}>
              <div className="flex items-start justify-between gap-3" data-id="element-211" data-mp="182i599elp4rx">
                <QuoteIcon className="h-7 w-7 shrink-0 text-accent" strokeWidth={1.8} aria-hidden="true" data-id="element-212" data-mp="184l14a2fps4k" />
                {!testimonial.verified ? <span className="rounded-md border border-dashed border-line px-2 py-1 text-[0.65rem] font-semibold uppercase leading-tight tracking-wide text-muted" data-id="element-213" data-mp="32hau8pkzaxaw">
                    Replace with verified testimonial
                  </span> : null}
              </div>
              <blockquote className="mt-4 text-lg leading-relaxed text-fg" data-id="element-214" data-mp="2q0n7o62sl5rm">
                “{testimonial.quote}”
              </blockquote>
              <div className="mt-auto pt-6" data-id="element-215" data-mp="2ztc8m70pv18p">
                <p className="border-t border-line pt-5 font-display text-lg font-bold uppercase tracking-wide text-fg" data-id="element-216" data-mp="2zudtf37jb23m">
                  {testimonial.role}
                </p>
                <p className="mt-0.5 text-sm text-muted" data-id="element-217" data-mp="2756nvk9nxc8v">{testimonial.country}</p>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}